import React from 'react';
import { SelectConnection } from 'new/elements/flows/SelectConnection';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import flowTypes from 'new/components/flows/types/flowTypes';
import useSpark from 'new/components/flows/types/spark/useSpark';
import useConnectionsPage from 'new/components/flows/controller/useConnectionsPage';

interface SelectConnectionPageProps {}

export const SelectConnectionPage: FCFormPageType<SelectConnectionPageProps> = (
  props: SelectConnectionPageProps,
) => {
  const { nextPage } = useForm();
  const { connectionType, selectedConnection, onSelectConnection } = useSpark();
  useConnectionsPage(selectedConnection);

  const onConnectionSelected = (selectedConnection: string) => {
    onSelectConnection(selectedConnection);
    nextPage(null, true);
  };

  return (
    <SelectConnection
      flowType={flowTypes.spark}
      connectionType={connectionType}
      selectedConnection={selectedConnection}
      onConnectionSelected={onConnectionSelected}
    />
  );
};

SelectConnectionPage.formConfig = {
  title: 'Connect',
};
